import UploadSpinner from './UploadSpinner';

export default UploadSpinner;